<template>
    <v-toolbar card color="transparent" prominent dense>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="filterEnabled" flat @click.stop="toggleFilters" title="Toggle Filters">Filters</v-btn>
    </v-toolbar>
</template>

<script>
export default {
  name: 'SearchToolbar',
  props: {
    title: String,
    filterEnabled: Boolean
  },
  data: () => ({
    filterSwitch: false
  }),
  methods: {
    toggleFilters () {
      this.$events.emit('APP_FILTERS_TOGGLED', null)
    }
  }
}
</script>

<style scoped>

</style>
